import { combineReducers } from 'redux'
import cookie from 'react-cookie'

import {setterReducer} from '../common/redux'
import * as t from './actionTypes'
import status from './status'

const initEmail = ''

export const email = (state = initEmail, action) => {
  switch (action.type) {
    case t.SET_EMAIL:
      cookie.save('email', action.payload.trim(), {path: '/'})
      return action.payload.trim()
    case t.LOGOUT:
    case t.SET_PASS_ERROR:
    case t.REQUEST_RESET_ERROR:
    case t.PASS_RESET_ERROR:
      return initEmail
    default:
      return state
  }
}

export const betaSubmitted = setterReducer(false, t.SET_BETA_SUBMITTED)

export const resetActivated = setterReducer(false, t.SET_RESET_ACTIVATED)

export const canRegister = setterReducer(false, t.SET_CAN_REGISTER)

export const viewedCookiePolicy = setterReducer(null, t.SET_VIEWED_COOKIE_POLICY)

export const signupMessage = (state = '', action) => {
  switch (action.type) {
    case t.SET_SIGNUP_MESSAGE:
      return action.payload
    case t.LOGIN_SUCCESS:
      return ''
    default:
      return state
  }
}

export const firstTime = (state = false, action) => {
  switch (action.type) {
    case t.SET_FIRST_TIME:
      return action.payload
    case t.SET_PASS_SUCCESS:
    case t.SIGNUP_SUCCESS:
      return true
    default:
      return state
  }
}

export const isAnonymous = (state = true, action) => {
  switch (action.type) {
    case t.SET_IS_ANONYMOUS:
      return action.payload
    case t.LOGIN_SUCCESS:
      return false
    default:
      return state
  }
}


const authReducer = combineReducers({
  firstTime,
  viewedCookiePolicy,
  email,
  status,
  betaSubmitted,
  resetActivated,
  canRegister,
  isAnonymous,
  signupMessage
})

export {authReducer as default}



// WEBPACK FOOTER //
// ./assets/auth/reducer.js